import VirtualGroup from './virtual-group.js';
import BthomeDevice from './bthome-device.js';
import PeripheralDevice from './peripheral-device.js';

export const Virtual = {
	'virtual-group': VirtualGroup,
	'bthome-device': BthomeDevice,
	'peripheral-device': PeripheralDevice,
};
